import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import useAuth from "../../hooks/useAuth";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';




const AdminGurudakshinaSummary = () => {

  const [summaryType, setSummaryType] = useState("VIBHAG");
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinasPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { auth } = useAuth();

  const [pranthList, setPranthList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState("");

  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [vibhagList, setVibhagList] = useState([]);

  const [selectedJillaId, setSelectedJillaId] = useState("");
  const [jillaList, setJillaList] = useState([]);

  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");


  const [selectedSthanId, setSelectedSthanId] = useState("");
  const [sthanList, setSthanList] = useState([]);

  const [sakhaList, setSakhaList] = useState([]);

  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [khandList, setKhandList] = useState([]);



  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");
  const [Sthans, setSthans] = useState([]);

  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };
    setSelectedPranthId("1");
    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);



  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };


  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {

        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);
          // setSthans([]);
          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);



  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);

  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);




  const fetchArthiksakhaList = async (selectedJillaId) => {
    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?jilla_id=${selectedJillaId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthiksakhasList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Arthiksakha", err);
      setArthiksakhasList([]);
      return [];
    }
  };

  useEffect(() => {
    if (selectedJillaId) {
      fetchArthiksakhaList(selectedJillaId); // ✅ pass the value
    }
  }, [selectedJillaId]);






  const searchList = async () => {
    try {

      setHasSearched(true);   // 👈 Mark that search started
      setLoading(true);

      let summaryTypeParam = "";
      let url = "/gurudakshina-summary?";

      switch (summaryType) {
        case "VIBHAG":
          summaryTypeParam = `summary_type=VIBHAG` +
            `&vibhag_id=${selectedVibhagId}` +
            `&jilla_id=${selectedJillaId}` +
            `&arthik_sakha_id=${selectedArthiksakhasId}` +
            `&khand_id=${selectedKhandId}` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "JILLA":
          summaryTypeParam = `summary_type=JILLA` +
            `&jilla_id=${selectedJillaId}` +
            `&arthik_sakha_id=${selectedArthiksakhasId}` +
            `&khand_id=${selectedKhandId}` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "ARTHIKSAKHA":
          summaryTypeParam = `summary_type=ARTHIKSAKHA` +
            `&arthik_sakha_id=${selectedArthiksakhasId}` +
            `&khand_id=${selectedKhandId}` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "KHAND":
          summaryTypeParam = `summary_type=KHAND` +
            `&khand_id=${selectedKhandId}` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;


        case "MANDAL":
          summaryTypeParam = `summary_type=STHAN` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "STHAN":
          summaryTypeParam = `summary_type=STHAN` +
            `&sthan_id=${selectedSthanId}`;
          break;

        default:
          alert("Please select a Summary Type");  // show message
          return;
      }

      const res = await axiosPrivate.get(`${url}${summaryTypeParam}`);
      setGurudakshinas(res.data);
      setLoading(false);

    } catch (err) {
      console.error("Failed to search", err);
      setLoading(false);
    }
  };




  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedMandalamId) {
        setSthanList([]);
        setSelectedSthanId("");
        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = "";
          setSelectedSthanId("");  // force change
          setTimeout(() => {
            setSelectedSthanId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedSthanId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSthanList();
  }, [selectedMandalamId]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);

  const fetchKhands = useCallback(async () => {
    if (!selectedArthiksakhasId) return;

    setLoading(true);
    // setMandalams([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${selectedArthiksakhasId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        const firstKhandId = "";
        setSelectedKhandId("");            // <- force a change
        setTimeout(() => {
          setSelectedKhandId(firstKhandId);  // <- this will retrigger the useEffect
        }, 0);
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedArthiksakhasId]);


  useEffect(() => {
    fetchKhands();
  }, [selectedArthiksakhasId]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = "";
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);


  useEffect(() => {
    setGurudakshinas([]);
    setHasSearched(false);
  }, [summaryType, selectedPranthId, selectedVibhagId, selectedJillaId, selectedArthiksakhasId, selectedKhandId, selectedMandalamId, selectedSthanId]);



  const handleViewClick = (gurudakshinaId) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/view/gurudakshina/${gurudakshinaId}`);
  };
  const handleEditClick = (gurudakshinaId) => {
    navigate(`/edit/gurudakshina/${gurudakshinaId}`);
  }


  const indexOfLastGurudakshina = currentPage * gurudakshinasPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinasPerPage;
  const currentGurudakshina = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinasPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      <style>
        {`
        #customers th, #customers td {
          min-width: 100px;
        }
      `}
      </style>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Gurudakshina Summary Report</h3>
          <Row className="mb-3 newrowstyle" style={{ justifyContent: "normal  !important;" }}>

            <Col md={2}>
              <Form.Label className="newformstyle">Summary Type</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={summaryType}
                // onChange={(e) => setSummaryType(e.target.value)}
                onChange={(e) => {
                  setSummaryType(e.target.value);
                  // setSelectedPranthId(""); // ✅ Reset Khand dropdown
                  // setVibhagList([]);
                  setJillaList([]);
                  setKhandList([]);
                  setArthiksakhasList([]);
                  setMandalamList([]);
                  setSthanList([]);

                }}
              >
                <option value="">-- Select Summary Type --</option>
                <option value="VIBHAG">Vibhag</option>
                <option value="JILLA">Jilla</option>
                <option value="ARTHIKSAKHA">Arthiksakha</option>
                <option value="KHAND">Khand</option>
                <option value="MANDAL">Mandalam</option>
                <option value="STHAN">Sthan</option>
              </Form.Select>
            </Col>



            <Col md={2}>
              <Form.Label className="newformstyle">Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setJillaList([]);
                    setKhandList([]);
                    setArthiksakhasList([]);
                    setMandalamList([]);
                    setSthanList([]);
                    setSelectedArthiksakhasId("");


                  }
                }}
              // disabled={!summaryType || !pranthList}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            {["VIBHAG", "JILLA", "ARTHIKSAKHA", "KHAND", "MANDAL", "STHAN"].includes(summaryType) && (

              <Col md={2}>
                <Form.Label className="newformstyle">Vibhag</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedVibhagId}
                  onChange={(e) => {
                    const vibhagId = e.target.value;
                    setSelectedVibhagId(vibhagId);

                    if (!vibhagId) {
                      // Clear Jilla list and selection if no Vibhag selected
                      setJillaList([]);
                      setSelectedJillaId("");
                      setSthans([]); // Optional: clear table too
                      setKhandList([]);
                      setSelectedKhandId("");
                    }
                  }}
                  disabled={!selectedPranthId || !vibhagList.length}
                >
                  <option value="">-- Select Vibhag --</option>
                  {Array.isArray(vibhagList) &&
                    vibhagList.map((v) => (
                      <option key={v.vibhag_id} value={v.vibhag_id}>
                        {v.vibhag_name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            )}

            {["JILLA", "ARTHIKSAKHA", "KHAND", "MANDAL", "STHAN"].includes(summaryType) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Jilla</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedJillaId}
                  onChange={(e) => {
                    const jillaId = e.target.value;
                    setSelectedJillaId(jillaId); // ✅ Just update state


                    if (!jillaId) {
                      setKhandList([]);
                      setSelectedKhandId("");
                      // setSthans([]);
                    }
                  }}
                  disabled={!jillaList.length}
                >
                  <option value="">-- Select Jilla --</option>
                  {jillaList.map((j) => (
                    <option key={j.jilla_id} value={j.jilla_id}>
                      {j.jilla_name}
                    </option>
                  ))}
                </Form.Select>

              </Col>
            )}

            {["ARTHIKSAKHA", "KHAND", "MANDAL", "STHAN"].includes(summaryType) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Arthiksakha</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedArthiksakhasId}
                  onChange={(e) => {
                    const ArthiksaId = e.target.value;
                    setSelectedArthiksakhasId(ArthiksaId);

                    if (!ArthiksaId) {
                      // Clear Jilla list and selection if no Vibhag selected
                      // setJillaList([]);

                      // setKhandList([]);
                      // setSelectedKhandId("");

                    }
                  }}
                  disabled={!selectedJillaId || !arthiksakhasList.length}
                >
                  <option value="">-- Select Arthiksakhas --</option>
                  {Array.isArray(arthiksakhasList) &&
                    arthiksakhasList.map((v) => (
                      <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                        {v.arthik_sakha}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            )}

            {["KHAND", "MANDAL", "STHAN"].includes(summaryType) && (

              <Col md={2}>
                <Form.Label className="newformstyle">Khand</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedKhandId}
                  onChange={(e) => setSelectedKhandId(e.target.value)}
                  disabled={!selectedArthiksakhasId || !khandList.length}
                >
                  <option value="">-- Select Khand --</option>
                  {khandList.map((k) => (
                    <option key={k.khand_id} value={k.khand_id}>
                      {k.khand_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            {["MANDAL", "STHAN"].includes(summaryType) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Mandalam</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedMandalamId}
                  onChange={(e) => {
                    const mandalamId = e.target.value;
                    setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                    // Remove this:
                    // setSelectedKhandId(khandId);
                    // setMandalamList([]);
                    // setSthans([]);
                  }}
                  disabled={!selectedKhandId || !mandalamList.length}
                >

                  <option value="">-- Select Mandalam --</option>
                  {mandalamList.map((m) => (
                    <option key={m.mandal_id} value={m.mandal_id}>
                      {m.mandal_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            {summaryType === "STHAN" && (

              <Col md={2}>
                <Form.Label className="newformstyle">Sthan</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedSthanId}
                  onChange={(e) => {
                    const sthanId = e.target.value;
                    setSelectedSthanId(sthanId);
                  }}
                  disabled={!selectedMandalamId || !sthanList.length} // 🔒 Disable if no Mandalam selected
                >
                  <option value="">-- Select Sthan --</option>
                  {sthanList.map((m) => (
                    <option key={m.sthan_id} value={m.sthan_id}>
                      {m.sthan_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            <Col md={2} className="d-flex align-items-end">
              <button type="button" className="btn orange_btn newbtnstyles newstyleset" onClick={searchList} disabled={!summaryType}>
                Search
              </button>
            </Col>
            <Col md={6}></Col>

          </Row>
          {hasSearched && (
            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Vibhag</th>
                    <th>Jilla</th>
                    <th>Arthiksakha</th>
                    <th>Khand</th>
                    <th>Mandal</th>
                    <th>Sthan</th>
                    <th colSpan="2">Vidyarthi Samyuktha</th>
                    <th colSpan="2">Vidyarthi Tharuna</th>
                    <th colSpan="2">Vyavasayi Tharuna</th>
                    <th colSpan="2">Prouda</th>
                    <th colSpan="2">Total</th>
                  </tr>
                  <tr>
                    <th colSpan="6"></th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="16" className="text-center text-primary">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="13" className="text-danger text-center">{error}</td>
                    </tr>
                  ) : gurudakshinas.length === 0 ? (
                    <tr>
                      <td colSpan="13">No Data available.</td>
                    </tr>
                  ) : (

                    currentGurudakshina.map(g => (
                      <tr key={g.id}>
                        <td>{g.vibhag_name}</td>
                        <td>{g.jilla_name}</td>
                        <td>{g.arthik_sakha}</td>
                        <td>{g.khand_name}</td>
                        <td>{g.mandal_name}</td>
                        <td>{g.sthan_name}</td>

                        <td>{g.VISUpasthith}</td>
                        <td>{g.VISAmount}</td>

                        <td>{g.VITUpasthith}</td>
                        <td>{g.VITAmount}</td>

                        <td>{g.VYTUpasthith}</td>
                        <td>{g.VYTAmount}</td>
                        <td>{g.PUpasthith}</td>
                        <td>{g.PAmount}</td>
                        <td>{g.TotalUpasthith}</td>
                        <td>{g.TotalaAmount}</td>
                      </tr>
                    ))

                  )}
                </tbody>

                {/* ✅ Totals Row */}
                {gurudakshinas.length > 0 && (
                  <tfoot>
                    <tr>
                      {/* This spans exactly the first 6 columns */}
                      <th colSpan="6">Total</th>

                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VISUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VISAmount || 0), 0)}</b>
                      </td>

                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VITUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VITAmount || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VYTUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VYTAmount || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.PUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.PAmount || 0), 0)}</b>
                      </td>

                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.TotalUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.TotalaAmount || 0), 0)}</b>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>


              {/* ✅ Totals Table */}
              {/* {gurudakshinas.length > 0 && (
              <table id="customers" className="mt-4">

                <tbody>
                  <tr>
                    <th colSpan="12" style={{ width: "100%" }}>Total</th>

                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VITUpasthith || 0), 0)}</td>
                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VITAmount || 0), 0)}</td>

                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VISUpasthith || 0), 0)}</td>
                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VISAmount || 0), 0)}</td>

                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VYTUpasthith || 0), 0)}</td>
                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.VYTAmount || 0), 0)}</td>

                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.PUpasthith || 0), 0)}</td>
                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.PAmount || 0), 0)}</td>

                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.TotalUpasthith || 0), 0)}</td>
                    <td>{gurudakshinas.reduce((sum, g) => sum + (g.TotalaAmount || 0), 0)}</td>
                  </tr>
                </tbody>
              </table>
            )} */}

            </div>
          )}

          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default AdminGurudakshinaSummary;